// extracted by mini-css-extract-plugin
export default {"modal":"mO-z","modalOverlay":"nO-z","outfitHeading":"oO-z"};